import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineProps } from "vue/dist/vue";
import TextBase from "@/components/Texts/TextBase.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextMedium',
  props: {
    text: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextBase, {
    class: "text-lg md:text-xl",
    text: props.text
  }, null, 8, ["text"]))
}
}

})